<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "VehicleExpatriate",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "hirecar",
      getOptionUrl: 'addpro',
      title: "添加",
      breadcrumb: [{ name: "车辆管理" }, { name: "雇佣车辆" }],
      formInline: {},
      viewMode: false,
      formCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
      ],
      mform: {
        license: undefined,
        pcusid: undefined,
        driver: undefined,
        phone: undefined,
      },
      mrules: {
        // license: [
        //   { required: true, validator: this.checkLicense, trigger: "blur" },
        // ],
        license: [
          { required: true, message: "请填写车牌号", trigger: "blur" },
        ],
        pcusid: [
          {
            required: true,
            message: '请选择承运联系人',
            trigger: 'blur',
          }
        ],
        driver: [
          {
            required: true,
            message: '请填写司机姓名',
            trigger: 'blur',
          }
        ],
        phone: [
          {
            required: true,
            validator: this.checkPhone,
            trigger: 'blur',
          },
        ],
      },
      mformCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
        },
        {
          label: "承运公司",
          keyName: "pcusid",
          err: "请选择承运公司",
          type: "select",
          options: [],
        },
        {
          label: "司机",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
        },
        {
          label: "联系方式",
          keyName: "phone",
          err: "请填写联系方式",
          type: "text",
        },
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "company", label: "公司名称" },
        { prop: "driver", label: "司机姓名" },
        { prop: "phone", label: "电话" },
      ],
      btns: [
        // {
        //   ...this.viewBtn,
        //   cb: ({ id }) => {
        //     // this.$router.push(`/vehicle/expatriateview?id=${id}&mode=view`);
        //     console.log(id)
        //     this.showDialog()
        //   },
        // },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            // this.$router.push(`/vehicle/expatriatedetail?mode=edit&id=${id}`);
            // console.log(id);
            this.title = "雇佣车辆编辑";
            this.getData(id);
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
      ],
    };
  },
  methods: {
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          params[key] = value;
        }
      }

      const opt = params.id ? 'update' : 'create'

      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'hire_car',
      }
    },

    delParamsPackage(params) {
      params['headers'] = {
        'X-Method': 'delete',
        'X-Module': 'hire_car',
      }

      // console.log('params', { ...params })
    },

    addItem() {
      //   this.$router.push(`/vehicle/expatriatedetail`);
      this.title = '雇佣车辆添加'
      this.mform = {
        license: '',
        pcusid: undefined,
        driver: '',
        phone: '',
      };
      this.showDialog();
    },
    getData(id) {
      this.loading = true;
      let url = `${this.baseUrl}/item`;
      const params = {
        userid: this.user.id,
        id,
      };
      this.mform['id'] = id
      this.post(
        url,
        params,
        (res) => {
          const { msg, data } = res;
          if (msg === "success" && data) {
            // console.log(data);
            this.mformCtrl.map((v) => {
              const key = v.keyName;
              this.mform[key] = data[key];
              this.showDialog();
            });
          } else {
            this.$message({
              type: "error",
              message: "加载失败，请稍后再试！",
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    setOptions({ data }) {
      this.mformCtrl.map(v => {
        if (v.keyName == 'pcusid') {
          v.options = data.map(val => {
            return {
              label: val.company,
              value: val.id,
            }
          })
        }
      })
    },
  },
  mounted() {
    this.getOptions();
    // this.tabIdx = this.tabIdxMemo(this.$route.path) || 0
  },
};
</script>
<style lang="less" scoped>
/deep/ .dialog {
  .el-form {

    .el-input,
    .el-textarea {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}
</style>